import { Btn, ExternalLink, Eyebrow, Icon, Rings } from '@ui/library';
import type { Hero as HeroData } from '@lib/schemas/site';

const HERO_LINKS: ReadonlyArray<{ key: string; iconName: string; label: string }> = [
  { key: 'blog',     iconName: 'pen-line', label: 'Blog' },
  { key: 'linkedin', iconName: 'linkedin', label: 'LinkedIn' },
  { key: 'github',   iconName: 'github',   label: 'GitHub' },
  { key: 'x',        iconName: 'twitter',  label: 'X' },
];

export interface HeroProps {
  hero: HeroData;
  links: Record<string, string>;
  avatarSrc?: string;
  portalSrc?: string;
}

export function Hero({
  hero,
  links,
  avatarSrc = '/assets/alison-avatar.png',
  portalSrc = '/assets/logo-portal.svg',
}: HeroProps) {
  return (
    <header className="hero wrap" id="top">
      <Rings style={{ left: '-30%', top: '-40%', opacity: 0.6 }} />
      <div className="hero__grid">
        <div>
          <Eyebrow>{hero.eyebrow}</Eyebrow>
          <h1>
            {hero.headlinePrefix}{' '}
            <span className="aw-grad-text">{hero.headlineEmphasis}</span>.
          </h1>
          <p className="hero__lead">{hero.lead}</p>
          <div className="hero__cta">
            <Btn kind="primary" href={hero.ctaPrimary.href} icon={hero.ctaPrimary.icon} target="_blank">
              {hero.ctaPrimary.label}
            </Btn>
            <Btn kind="ghost" href={hero.ctaSecondary.href} icon={hero.ctaSecondary.icon}>
              {hero.ctaSecondary.label}
            </Btn>
          </div>
          <div className="hero__links">
            {HERO_LINKS.map(
              ({ key, iconName, label }) =>
                links[key] && (
                  <ExternalLink key={key} href={links[key]!}>
                    <Icon name={iconName} size={15} />{label}
                  </ExternalLink>
                )
            )}
            {links['email'] && (
              <a href={`mailto:${links['email']}`}>
                <Icon name="mail" size={15} />Email
              </a>
            )}
          </div>
        </div>
        <div className="hero__portrait">
          <div className="orbit2" />
          <div className="orbit" />
          <div className="frame">
            <img className="ava" src={avatarSrc} alt="Alison Haire" />
            <img className="moth" src={portalSrc} alt="" />
          </div>
        </div>
      </div>
    </header>
  );
}
